export default __webpack_public_path__ + "static/media/nayeon.5ce7b721.jpg";